import type { TMessages } from '@/types/TMessages'

export const messages = {
  notification: {
    title: 'Данные сохранены, документы отправлены на проверку',
    description: 'Вы получите уведомление об окончании проверки по СМС, информация также будет доступна в личном кабинете',
  },
} satisfies TMessages
